import React, { Component } from 'react';
        
import Button from 'base/components/Button';
import Toolbar from 'base/components/common/Toolbar';

import ExcelForm from '../components/ExcelForm';
import auth from 'base/auth';
import API from 'base/api';

class AddExcelView extends Component {
  handleSubmit = (file, number) => {
    let data = new FormData();
    data.append('file', file);
    data.append('number', number);

    if ( file !== undefined && number !== "" ) {
      fetch(API.EXCEL_UPLOAD, {
        method: 'POST',
        body: data, 
        headers: new Headers({
          "Authorization": auth.getToken()
        })
      })
      .then( res => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('Something went wrong ...');
        }
      })
      .then( res => {
        console.log("Success:", res)
      })
      .catch(error => console.log("Error ", error ));
    }
  }

  render() {
    return (
      <div>
        <Toolbar title="< Panel admina | Dodawanie excela" titleUrl="/admin" />
        <p>nie dziala xd</p>
        <ExcelForm onSubmit={this.handleSubmit} />
      </div>
    );
  }
}

export default AddExcelView;



// WEBPACK FOOTER //
// ./src/modules/Admin/views/AddExcelView.js